import { styled, theme } from 'design-system';
import { AnimatePresence, motion, Variants } from 'framer-motion';
import { PropsWithChildren } from 'react';

const variants: Variants = {
  offscreen: {
    right: '-100%',
    width: '100%',
  },
  onscreen: {
    right: 0,
    width: '100%',
  },
};

const Container = styled(motion.div, {
  position: 'fixed',
  right: 0,
  top: 0,
  paddingRight: 10,
  width: '650px',
  height: 'calc(100%)',
  background: 'rgba(255, 255, 255, 0.5)',
  zIndex: 3,
  borderRadius: '10px', // Add round borders
});

const SubContainer = styled('div', {
  width: '750px',
  height: '98%',
  overflowY: 'auto',
  paddingTop: '35px',
  top: '1%',
  bottom: '1%',
  backgroundColor: theme.colors.white,
  float: 'right',
  position: 'relative',
  borderRadius: '10px 0px 0px 10px',
  marginRight: '10px',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', // Add shadow effect
  border: `2px solid ${theme.colors.gray8}`, // Add border
});

export const SlideNew = (props: PropsWithChildren<{ open: boolean }>) => {
  return (
    <AnimatePresence>
      {props.open && (
        <Container
          transition={{
            default: { ease: 'linear' },
          }}
          variants={variants}
          initial={'offscreen'}
          animate={'onscreen'}
          exit={'offscreen'}
          key={'slider'}
        >
          <SubContainer>{props.children}</SubContainer>
        </Container>
      )}
    </AnimatePresence>
  );
};
